import React, { useState, useEffect } from 'react';
import { FixedSizeList } from 'react-window';

// Material UI
import MenuItem  from '@mui/material/MenuItem';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import { makeStyles } from 'tss-react/mui';

// Icons
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

// Hooks
import useUser from '../../../hooks/user/useUser';

// Models
import { subChannels } from '../../../models/Channels';

const itemHeight = 48;

const useStyles = makeStyles()(theme => ({
    nested: {
        paddingLeft: theme.spacing(4)
    },
}));

const SelectPvMenu = () => {
    const { classes } = useStyles();
    const { branch, pv, SelectPv, cashRegister } = useUser();
    const [open, setOpen] = useState(false);
    const [items, setItems] = useState([]);

    useEffect(() => {
        if(branch?.pvs && cashRegister.associatePvs) {
            const pvs = branch.pvs
                .filter(item => item.active)
                .filter(item => item.subChannel === subChannels.values.POS)
                .filter(pv => cashRegister.associatePvs.some(pva => pva.pvId === pv.id))

            let pvSelected = pv 
                ? pvs.find(p => p.id === pv.id)
                : null;

            if(!pvSelected && pvs.length > 0)
                pvSelected = pvs[0];

            setItems( pvs );
            SelectPv( pvSelected );
        }
// TODO: Revisar esta linea
// eslint-disable-next-line react-hooks/exhaustive-deps
}, [branch?.pvs, cashRegister?.associatePvs])

    const handleClick = () => {
        setOpen(!open);
    };

    const handleSelect = ( pv ) => {
        SelectPv(pv);
        setOpen(false);
    }

    if(!branch)
        return null;

    const RenderRow = ({ index, style }) => {
        const item = items[index];

        return (
            <ListItem 
                button 
                style={style}  
                key={item.billingCode} 
                selected={ item.billingCode === pv?.billingCode }
                onClick={() => handleSelect(item)}
                className={classes.nested}
            >
                <ListItemText primary={item.name} />
            </ListItem>
        )
    }

    const GetMaxHeight = () => 
        items.length < 3
            ? itemHeight * items.length
            : itemHeight * 3;

    return (
        <>
            <MenuItem 
                disabled={items.length <= 0}
                onClick={handleClick}
            >
                <ListItemText 
                    primary='Punto de venta' 
                    secondary={pv?.name}
                />
                {open ? <ExpandLess /> : <ExpandMore />}
            </MenuItem>
            <Collapse in={open} timeout='auto' unmountOnExit>
                <FixedSizeList height={GetMaxHeight()} itemSize={itemHeight} itemCount={items.length}>
                    {RenderRow}
                </FixedSizeList>
            </Collapse>
        </>
    )
}

export default SelectPvMenu;